import { extend } from 'lodash';

const REGULAR_FONT_SIZE = '16px';
const XSMALL_FONT_SIZE = '12px';

function _theme(Highcharts) {
  let theme = {
    colors: [
      '#aa3590',
      '#33C3F0',
      '#B8C563',
      '#04aceb',
      '#29cdb5',
      '#ff00ff',
      '#64E572',
      '#FF9655',
      '#D9FF89',
      '#6AF9C4',
    ],
    textColor: '#fffefc',
    contrastTextColor: '#fffefc',
    dataLabelsColor: '#fffefc',
    TransColor: '#323e4a',
    chart: {
      backgroundColor: null,
      style: {
        fontFamily: 'Roboto',
        fontSize: XSMALL_FONT_SIZE,
        shadow: false,
        textShadow: 'none',
      },
      spacingBottom: 5,
      spacingTop: 0,
      marginTop: 5,
      spacingLeft: 0,
      spacingRight: 0,
    },
    tooltip: {
      backgroundColor: 'rgba(0,0,0,0.7)',
      borderWidth: 0,
      style: {
        color:
          (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'white',
        textShadow: 'none',
        fontSize: XSMALL_FONT_SIZE,
      },
    },
    legend: {
      enabled: false,
      itemStyle: {
        color: '#fffefc',
      },
    },
    lang: {
      thousandsSep: ',',
    },
    title: {
      text: '',
    },
    yAxis: {
      title: {
        style: {
          fontSize: XSMALL_FONT_SIZE,
          color: '#fffefc',
          'text-shadow': '0 0 5px rgba(0, 0, 0, 0.61)',
          textOverflow: 'none',
        },
      },
      labels: {
        style: {
          fontSize: XSMALL_FONT_SIZE,
          color: '#fffefc',
          textOverflow: 'none',
        },
      },
      stackLabels: {
        style: {
          fontFamily: 'Roboto',
          color: (Highcharts.theme && Highcharts.theme.textColor) || '#fffefc',
          fontSize: REGULAR_FONT_SIZE,
          'text-shadow': '0 0 5px rgba(0, 0, 0, 0.61)',
          textOverflow: 'none',
        },
      },
    },
    xAxis: {
      labels: {
        style: {
          fontSize: XSMALL_FONT_SIZE,
          color: '#fffefc',
          textOverflow: 'none',
        },
      },
    },
    plotOptions: {
      series: {
        animation: false,
        dataLabels: {
          style: {
            style: {
              fontSize: XSMALL_FONT_SIZE,
              textOverflow: 'none',
            },
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    defs: {
      patterns: [
        {
          id: 'negative-pattern',
          path: {
            d: 'M 0,4 4,0 M -1,1 1,-1 M 3,5 5,3',
            stroke: 'rgba(255, 80, 80,0.7)',
            strokeWidth: 1.2,
          },
          width: 4,
          height: 4,
        },
      ],
    },
  };

  if (
    window !== null &&
    window.matchMedia &&
    window.matchMedia('only screen and (max-width: 479px)').matches
  ) {
    var mobileTheme = {
      plotOptions: {
        series: {
          shadow: false,
          animation: false,
          enableMouseTracking: false,
          dataLabels: {
            style: {
              textShadow: 'none',
            },
          },
          tooltip: {
            followPointer: false, // this is already the default, it's just to stress what's said in commit comments and make code "speak"
            followTouchMove: false, // this is already the default, it's just to stress what's said in commit comments and make code "speak"
          },
        },
      },
    };

    theme = extend(theme, mobileTheme);
  }
  return theme;
}

export default _theme;
